import { defineComponent, useModel, openBlock, createBlock, unref, withCtx, createElementVNode, withModifiers, renderSlot, createVNode, createTextVNode, createCommentVNode, mergeModels } from 'vue';
import { ElPopover, ElButton } from 'element-plus';
/* empty css                                                                                                                                        */
/* empty css                                                                                                                                             */
/* empty css                                                                                                                                             */
/* empty css                                                                                                                                              */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "popover",
  props: /* @__PURE__ */ mergeModels({
    width: { default: 150 },
    placement: { default: "bottom" },
    showFooter: { type: Boolean, default: true }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["submit"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const model = useModel(__props, "modelValue");
    const emit = __emit;
    function submitHandler() {
      emit("submit");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ElPopover), {
        "popper-style": "padding: 0px",
        "hide-after": 0,
        width: __props.width,
        placement: __props.placement,
        trigger: "contextmenu",
        visible: model.value,
        "onUpdate:visible": ($event) => model.value = $event
      }, {
        reference: withCtx(() => [
          renderSlot(_ctx.$slots, "reference", {}, void 0, true)
        ]),
        default: withCtx(() => [
          createElementVNode("div", {
            class: "se-popover-container",
            onMousedown: withModifiers(() => {
            }, ["stop", "prevent"])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true),
            __props.showFooter ? renderSlot(_ctx.$slots, "footer", { key: 0 }, () => [
              createElementVNode("div", { class: "se-popover-footer" }, [
                createVNode(unref(ElButton), {
                  type: "primary",
                  size: "small",
                  onClick: submitHandler
                }, {
                  default: withCtx(() => [
                    createTextVNode("确定")
                  ]),
                  _: 1
                })
              ])
            ], true) : createCommentVNode("", true)
          ], 40, ["onMousedown"])
        ]),
        _: 3
      }, 8, ["width", "placement", "visible", "onUpdate:visible"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=popover.vue2.js.map
